import _Object$keys from 'babel-runtime/core-js/object/keys';
import { ICON_SIZES } from '../styled/constants';

export var validIconSizes = _Object$keys(ICON_SIZES);

export var propsOmittedFromClickData = ['onBlur', 'onClick', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/avatar/dist/esm/components/constants.js
// module id = 311
// module chunks = 0